import { createFileRoute } from '@tanstack/react-router';

import { ProductSearchPage } from '../../pages/product-search/ProductSearchPage';

export const Route = createFileRoute('/_auth/product-sheet/')({
  component: ProductSearchPage,
});
